import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const httpOptions = {
  headers: new HttpHeaders({
    "Access-Control-Allow-Origin": '*',
    "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token, Accept, Authorization, X-Request-With, Access-Control-Request-Method, Access-Control-Request-Headers",
    "Access-Control-Allow-Credentials": "true",
    "Access-Control-Allow-Methods": "GET, POST, DELETE, PUT, OPTIONS, TRACE, PATCH, CONNECT",
    "Access-Control-Max-Age": "300"
  })
}

@Injectable({
  providedIn: 'root'
})
export class AvisosService {

  API_URL: string = environment.API_URL;
  constructor(
    private http: HttpClient,
  ) { }


  saveAdvise(form:FormData){
    return this.http.post(`${this.API_URL}/aviso/save`,form);
  }

  getListAvisos(): any {
    return this.http.get(`${this.API_URL}/aviso/list`,{});
  }

  getAvisosVisible(): any{
    return this.http.get(`${this.API_URL}/aviso/visible/list`,{});
  }

  updateAvisos(id): any {
    return this.http.post(`${this.API_URL}/aviso/visible/${id}`,{});
  }
  
  updateCierreAviso(id, form: FormData): any {
    return this.http.post(`${this.API_URL}/aviso/fechaCierre/${id}`,form);
  }

  updateAperturaAviso(id, form: FormData): any {
    return this.http.post(`${this.API_URL}/aviso/fechaApertura/${id}`,form);
  }

  updateAviso(id, form: FormData): any {
    return this.http.post(`${this.API_URL}/aviso/editar/${id}`,form);
  }
  deleteAviso(id): any {
    return this.http.delete(`${this.API_URL}/aviso/borrar/${id}`);
  }
}
